import styled from "@emotion/styled"
import { Card } from "@blueprintjs/core"

import { FlexContainer } from "../../../../styled/flexbox.styled"
import { SCIENT_COLORS } from "../../../../styled/scientColors"

export const ApiKeysContainer = styled(FlexContainer)({
  padding: "30px 20px",
  maxWidth: "860px",
  margin: "0 auto",
  width: "100%",
  gap: "15px",
})

export const HeaderRow = styled(FlexContainer)({
  justifyContent: "space-between",
  alignItems: "flex-start",
  gap: "20px",
})

export const HeaderText = styled(FlexContainer)({
  flexDirection: "column",
  gap: "5px",
  p: {
    margin: 0,
    color: SCIENT_COLORS.gray4,
    maxWidth: "540px",
  },
})

export const TableCard = styled(Card)({
  padding: 0,
  overflow: "hidden",
  table: {
    width: "100%",
  },
  "th, td": {
    verticalAlign: "middle",
  },
})

export const EmptyStateCard = styled(Card)({
  padding: "50px 20px",
})

export const TokenBox = styled.code({
  display: "block",
  padding: "10px",
  marginTop: "10px",
  backgroundColor: SCIENT_COLORS.darkGray1,
  borderRadius: "3px",
  wordBreak: "break-all",
  userSelect: "all",
})

export const InactiveRow = styled.tr({
  opacity: 0.5,
})

export const MutedCell = styled.span({
  color: SCIENT_COLORS.gray3,
})
